import React from "react";

const PageHeader = (props) => {
    return (
        <>
            <div className="page-header">
                <div className="container-xl px-4">
                    <div className="page-header-title">
                        <div className="page-header-icon">
                            <i className={props.icon}></i>
                        </div>
                        {props.name}
                    </div>
                </div>
            </div>
        </>
    )
}

export default PageHeader;